export default "__VITE_ASSET__3bb46f6c__"